import { Box, CircularProgress } from '@mui/material';

import { BonusProposalProps } from '~/data/proposals';
import { useBonusProposalsLayout } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeBonusProposalsLayout/useBonusProposalsLayout';
import {
  EmployeeProposalsLayout,
  EmployeeProposalsLayoutProps,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeProposalsLayout/component';

export const EmployeeBonusProposalsLayout = (
  props: EmployeeProposalsLayoutProps<BonusProposalProps>,
) => {
  const { newProposal, ...passProps } = props;
  const { isLoading, ...bonusProps } = useBonusProposalsLayout(props);

  const layoutProps = {
    ...passProps,
    ...bonusProps,
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return <EmployeeProposalsLayout {...layoutProps} />;
};
